import { DollarSign, CalendarClock } from 'lucide-react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '~/components/ui/table';
import { formatCurrency, parseLocalDate, separateAndSortInvoices } from '~/utils/paymentUtils';

interface InvoiceSummaryTablesProps {
  invoiceSummary: any[];
}

/**
 * InvoiceSummaryTables - Display enrollment fees and upcoming tuition payments
 */
export function InvoiceSummaryTables({ invoiceSummary }: InvoiceSummaryTablesProps) {
  const { enrollmentFees, tuitionInvoices, dueNowTotal, dueLaterTotal } =
    separateAndSortInvoices(invoiceSummary);

  return (
    <>
      {/* Due Now Section */}
      {enrollmentFees.length > 0 && (
        <div className="border rounded-lg overflow-hidden">
          <div className="bg-primary/5 px-4 py-3 border-b">
            <h3 className="font-medium flex items-center gap-2">
              <DollarSign className="h-4 w-4" />
              Due Now
            </h3>
          </div>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Description</TableHead>
                <TableHead className="text-right">Amount</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {enrollmentFees.map((invoice: any, idx: number) => (
                <TableRow key={idx}>
                  <TableCell>{invoice.description}</TableCell>
                  <TableCell className="text-right">{formatCurrency(invoice.amount)}</TableCell>
                </TableRow>
              ))}
              <TableRow className="bg-primary/5 font-medium">
                <TableCell>Total Due Today</TableCell>
                <TableCell className="text-right text-primary">{formatCurrency(dueNowTotal)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      )}

      {/* Upcoming Payments Section */}
      {tuitionInvoices.length > 0 && (
        <div className="border rounded-lg overflow-hidden">
          <div className="bg-slate-50 px-4 py-3 border-b">
            <h3 className="font-medium flex items-center gap-2 text-muted-foreground">
              <CalendarClock className="h-4 w-4" />
              Upcoming Payments
            </h3>
          </div>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Description</TableHead>
                <TableHead>Charge Initiation Date</TableHead>
                <TableHead className="text-right">Amount</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {tuitionInvoices.map((invoice: any, idx: number) => (
                <TableRow key={idx}>
                  <TableCell>{invoice.description}</TableCell>
                  <TableCell>{parseLocalDate(invoice.dueDate)?.toLocaleDateString()}</TableCell>
                  <TableCell className="text-right">{formatCurrency(invoice.amount)}</TableCell>
                </TableRow>
              ))}
              <TableRow className="font-medium">
                <TableCell colSpan={2}>Total Upcoming</TableCell>
                <TableCell className="text-right">{formatCurrency(dueLaterTotal)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      )}
    </>
  );
}

export default InvoiceSummaryTables;
